import { renderAlert } from "../CommonComponents/Alert/Alert";
import ACTION_TYPES from "../redux/types";

export const paramsDecoder=()=> async (dispatch) =>{
    const urlParams = new URLSearchParams(window.location.search);
    const showPopup = urlParams.get('showOneDriveAlert');
    // If showPopup is true, set the popup visibility state to true
    if (showPopup === 'true') {
      setTimeout(()=>{dispatch({type:ACTION_TYPES.SET_USER_ACTIVITY_INFO,backupAllWorkbookstoOneDrive:true});},3000)
      
      renderAlert('We will now start taking backup of your workbooks in the background. We will let you know once this is complete.','success','5000')
    }
}
export const deleteParam=(paramToDelete)=>{
    urlParams.delete(paramToDelete);
    const newUrl =urlParams.size===0?window.location.pathname: window.location.pathname + '?' + urlParams.toString();
    window.history.replaceState({}, '', newUrl);
}